import { render, staticRenderFns } from "./msgText.vue?vue&type=template&id=6f01b002&scoped=true&"
import script from "./msgText.vue?vue&type=script&lang=js&"
export * from "./msgText.vue?vue&type=script&lang=js&"
import style0 from "./msgText.vue?vue&type=style&index=0&id=6f01b002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f01b002",
  null
  
)

export default component.exports